import React, { useContext } from 'react'
import AccessWith from '../../components/CreateAccess/AccessWith';
import CheckingAccess from '../../components/CreateAccess/CheckingAccess';
import ContractorsSelectable from '../../components/CreateAccess/ContractorsSelectable'
import Detail from '../../components/CreateAccess/Detail';
import EmployeeNoAccess from '../../components/CreateAccess/EmployeeNoAccess';
import ErrorAccess from '../../components/CreateAccess/ErrorAccess';
import SuccessAccess from '../../components/CreateAccess/SuccessAccess';
import VehicleForm from '../../components/CreateAccess/VehicleForm';
import VehiclesSelectable from '../../components/CreateAccess/VehiclesSelectable';
import VisitForm from '../../components/CreateAccess/VisitForm';
import { CustomAlert } from '../../components/CustomAlert/CustomAlert';
import AccessContext from '../../context/AccessContext/AccessContext';
import SelectArea from '../../components/CreateAccess/SelectArea';
import SelectPersonToVisit from '../../components/CreateAccess/SelectPersonToVisit';
import CreateEquipment from '../../components/CreateAccess/CreateEquipment';

const CreateAccess = () => {

    const { accessState } = useContext(AccessContext);
    const { error, message, step } = accessState

    const steps = {
        'CONTRACTOR_SELECTABLE': <ContractorsSelectable />,
        'VISIT_FORM': <VisitForm />,
        'ACCESS_WITH': <AccessWith />,
        'SELECT_EQUIPMENT_OR_TOOLS': <CreateEquipment />,
        'VEHICLES_SELECTABLE': <VehiclesSelectable />,
        'VISIT_VEHICLE_FORM': <VehicleForm />,
        'SELECT_AREA': <SelectArea />,
        'SELECT_PERSON_TO_VISIT': <SelectPersonToVisit />,
        'DETAIL': <Detail />,
        'SUCCESS_MOVEMENT': <SuccessAccess />,
        'ERROR_MOVEMENT': <ErrorAccess />,
        'EMPLOYEE_NO_ACCESS': <EmployeeNoAccess />,
    }

    const CurrentStep = step === '' ? <CheckingAccess /> : steps[step];

    return (
        <div className='h-100'>
            {error ? <CustomAlert color={'danger'} text={message} /> : null}
            {CurrentStep}
        </div>
    )
}

export default CreateAccess